import WorkLeave from "./WorkLeave";

export default WorkLeave;